import { render, staticRenderFns } from "./adPopup.vue?vue&type=template&id=0dc93316&scoped=true"
import script from "./adPopup.vue?vue&type=script&lang=js"
export * from "./adPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc93316",
  null
  
)

export default component.exports